import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  type CustomColor = 'red' | 'blue' | 'yellow' | 'green'

  interface Palette {
    custom: {
      colors: Record<CustomColor,string>,
      interface: {
        inputBorder: string
      }
    };
  }
  interface PaletteOptions {
    custom: {
      colors: Record<CustomColor,string>,
      interface: {
        inputBorder: string
      }
    };
  }
}

const theme = createTheme({
  spacing: 16,
  breakpoints: {
    // Default MUI values
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  },
  palette: {
    primary: {
      light: '#D8F3FF',
      main: '#000000',
      dark: '#005A8C'
    },
    secondary: {
      main: '#34573B'
    },
    success: {
      light: '#23AD0C',
      main: '#00641C'
    },
    error: {
      light: '#BC1046',
      main: '#BE0000'
    },
    background: {
      default: '#FFFFFF',
      paper: '#FAE0A2'
    },
    text: {
      primary: '#3A3A3A',
      secondary: '#747474'
    },
    custom: {
      colors: {
        blue: "#3057E6",
        green: "#34573B",
        red: "#e3513B",
        yellow: "#FAC649"
      },
      interface: {
        inputBorder: '#e3513B'
      }
    }
  },
  shape: {
    borderRadius: 8
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 16,
    fontFamily: 'Open Sans Regular, Arial',
    body1: {
      fontFamily: 'Open Sans Regular, Arial, sans-serif',
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '1.5'
    },
    body2: {
      fontFamily: 'Open Sans Regular, Arial, sans-serif',
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: '1.5'
    },
    button: {
      fontFamily: 'Chewy, system-ui',
      fontWeight: 700,
      fontSize: '1.25rem',
      lineHeight: '1.5',
      textTransform: 'none'
    }
  },
  // Ajout de la configuration des transitions globales
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.2s ease'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.5s ease'
        }
      }
    }
  }
});

theme.typography.h1 = {
  fontFamily: 'Chewy, system-ui',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '3rem',
  lineHeight: '1.75',
  [theme.breakpoints.down('md')]: {
    fontSize: '2rem'
  }
};

theme.typography.h2 = {
  fontFamily: 'Open Sans Regular, Arial, sans-serif',
  fontWeight: 400,
  fontSize: '2rem',
  lineHeight: '1.75',
  [theme.breakpoints.down('md')]: {
    fontSize: '1.5rem'
  }
};

theme.typography.h3 = {
  fontFamily: 'Open Sans SemiBold, Arial, sans-serif',
  fontWeight: 600,
  fontSize: '1.5rem',
  lineHeight: '1.5',
};

theme.typography.body1 = {
  fontFamily: 'Open Sans Regular, Arial, sans-serif',
  fontWeight: 400,
  fontSize: '1.25rem',
  lineHeight: '1.5'
};

export default theme;
